export enum POSType {
    Positouch = 0,
    Micros3700 = 1,
    MicrosSimphony = 2,
    Aloha = 3,
    Clear = 4,
    PixelPoint = 5,
    ParBrink = 6
}